function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.267 67.769c-10.225-.214-18.449-8.57-18.449-18.847 0-7.7 4.618-14.322 11.235-17.248.214-10.224 8.57-18.447 18.845-18.447 8.517 0 15.715 5.648 18.052 13.403a10.018 10.018 0 018.42-4.58c5.537 0 10.026 4.49 10.026 10.028a9.98 9.98 0 01-1.395 5.105c6.383 1.971 11.02 7.918 11.02 14.948 0 8.639-7.002 15.642-15.641 15.642-.134 0-.268-.002-.401-.005v.005H20.267v-.004z",
  fill: "#DFE8F6"
});

function SvgImage1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/image1.e25f76e5.svg";
export { SvgImage1 as ReactComponent };